import { Typography, Box } from "@mui/material";
import I18n from "i18next";
import SftpCard from "components/common/SftpCard";
import PartnerHosted from "./PartnerHosted";
import MarkaazHosted from "./MarkaazHosted";
import Loading from "components/common/Loading/Loading";

const cardData = [
  {
    header: "Partner Hosted SFTP Setup",
    checked: false
  },
  {
    header: "Markaaz Hosted SFTP Setup",
    checked: false
  }
];

const sx = {
  header: {
    color: "darkBlue.c100"
  },
  description: {
    color: "darkBlue.c100",
    width: "640px",
    paddingTop: "20px"
  },
  selectCard: {
    width: "224px"
  },
  label: {
    width: "175px",
    color: "darkBlue.c70",
    paddingTop: "40px"
  }
};

export default function SftpSettingsMain({
  loading,
  currentView,
  inputValues,
  connectionStatusAlert,
  pageData,
  showInputBox,
  fileInputRef,
  partnerHostedData,
  markaazHostedData,
  showUploadButton,
  partnerLoading,
  markaazLoading,
  disableUploadButton,
  disableSaveButton,
  connectionLoading,
  partnerHostedAlert,
  markaazHostedAlert,
  onTestConnection,
  onPanelChange,
  onSaveMarkaazHosted,
  onFileRemove,
  onDownload,
  onInputChange,
  onSubmit,
  onUpload,
  onFileInput,
  onEdit,
  onAlertClose
}) {
  return (
    <Box>
      <Typography variant="h4" sx={sx.header}>
        {I18n.t("sftpSettings.sftpSettings")}
      </Typography>
      <Typography variant="body2" sx={sx.description}>
        {I18n.t("sftpSettings.sftpSettingsDsc")}
      </Typography>
      <Typography variant="body2" sx={sx.label}>
        Select SFTP settings type:
      </Typography>

      {loading && <Loading />}
      {!loading && (
        <>
          <SftpCard sx={sx.selectCard} value={currentView} cardData={cardData} onPanelChange={onPanelChange} />
          {currentView === "Partner Hosted SFTP Setup" && (
            <PartnerHosted
              pageData={pageData.partnerHosted}
              connectionStatusAlert={connectionStatusAlert}
              inputValues={inputValues}
              disableSaveButton={disableSaveButton}
              showInputBox={showInputBox}
              loading={partnerLoading}
              connectionLoading={connectionLoading}
              partnerHostedData={partnerHostedData}
              partnerHostedAlert={partnerHostedAlert}
              onDownload={onDownload}
              onInputChange={onInputChange}
              onTestConnection={onTestConnection}
              onEdit={onEdit}
              onSubmit={onSubmit}
              onAlertClose={onAlertClose}
            />
          )}
          {currentView === "Markaaz Hosted SFTP Setup" && (
            <MarkaazHosted
              pageData={pageData.markaazHosted}
              loading={markaazLoading}
              showUploadButton={showUploadButton}
              disableUploadButton={disableUploadButton}
              fileInputRef={fileInputRef}
              markaazHostedData={markaazHostedData}
              markaazHostedAlert={markaazHostedAlert}
              onSaveMarkaazHosted={onSaveMarkaazHosted}
              onFileRemove={onFileRemove}
              onUpload={onUpload}
              onFileInput={onFileInput}
              onAlertClose={onAlertClose}
            />
          )}
        </>
      )}
    </Box>
  );
}
